<template lang="pug">
  .coupon-item
    v-card.elevation-0.px-3.py-1(style="border-radius:0px" @click="clickOpenVote(true)")
      v-row
        v-col.shrink
          v-layout.fill-height
            v-card.info500.text-center.my-auto(v-if="hasOwnVote" flat width="44px" height="44px" @click.stop="")
              eva-icon.mt-1(name="heart" :fill="$vuetify.theme.themes[$theme].basic100" width="12" height="12")
              .c2.basic100--text.mt-n1 {{ idea.vote_count }}
            v-card.basic400.text-center.my-auto(v-else flat width="44px" height="44px" @click.stop="clickOpenVote(false)")
              eva-icon.mt-1(name="heart" :fill="$vuetify.theme.themes[$theme].textColorAccent" width="12" height="12")
              .c2.textColorAccent--text.mt-n1 {{ idea.vote_count }}
        v-col
          .s1.primary500--text {{ idea.published_title }}
          .f2.primary400--text {{ idea.date_published | humanizeDate }} {{ profileDisplay }}
        v-col.shrink
          v-layout.fill-height
            eva-icon.my-auto(name="chevron-right" :fill="$vuetify.theme.themes[$theme].basic500" width="24" height="32")
    v-divider.basic400.mx-3

    .modals
      VoteIdeaDialog(v-if="openVoteDialog" :open.sync="openVoteDialog" :parentIdea.sync="idea" @edited="$emit('edited', $event)" :showDetails="showDetails" @vote-added="handleAddVote($event)" :hasOwnVote="hasOwnVote" :votes.sync="votes" :profile.sync="profile")

</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import VoteIdeaDialog from '@/components/dialogs/VoteIdea.vue'
export default {
  name: 'IdeaItem',
  props: ['parentIdea'],
  components: { VoteIdeaDialog },
  data: () => ({
    openVoteDialog: false,
    showDetails: false,
    votes:[],
    profile: null,
  }),
  computed: {
    ...mapState('user', ['feedbackApiUser', 'member']),
    ...mapGetters({
      company: 'getCompany'
    }),
    idea: {
      get() {
        return this.parentIdea
      },
      set(newValue) {
        this.$emit('edited', newValue)
      }
    },
    hasOwnVote () {
      return this.votes.length > 0
    },
    profileDisplay () {
      if (!this.profile) {
        return ''
      }
      return `by ${this.profile.name}, ${this.profile.company}`
    }
  },
  mounted () {
    this.getVotes()
    this.getProfiles()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    getVotes () {
      this.$feedbackApi.get(`/items/votes?filter={"_and":[{"feedback_id":{"_eq":"${this.idea.id}"}},{"user_id":{"_eq":"${this.feedbackApiUser.id}"}}]}`).then((response) => {
        if (response.data.data.length > 0) {
          this.votes = response.data.data
        }
      }).catch(() => {})
    },
    getProfiles() {
      this.$feedbackApi.get(`/items/profiles?filter={"user_id": { "_eq": "${this.idea.user_id.id}" }}`).then((response) => {
        if (response.data.data.length > 0) {
          this.profile = response.data.data[0]
        }
      }).catch(() => {})
    },
    clickOpenVote(showDetails) {
      this.showDetails = showDetails
      this.openVoteDialog = true
    },
    handleAddVote (item) {
      this.votes.splice(0, 0, item)
    }
  }
}
</script>

<style scoped>
.count-layout {
  position: absolute;
  right: 10px;
  top: 6px;
}
.product-title {
  font-size: 16px;
  font-weight: bold;
  height: 2.8em; 
  line-height: 1.4em; 
  overflow: hidden;
}
.product-description {
  font-size: 12px;
  height: 3.3em; 
  text-overflow: ellipsis; 
  line-height: 1.1em; 
  white-space: pre-wrap;
  overflow: hidden;
}
.product-price {
  font-size: 16px;
  font-weight: bold;
}
.count-list-layout {
  position: absolute;
  right: 4px;
}
.product-list-title {
  color:#2E2E2E;
  size: 9px;
  font-weight: bold;
}
.product-list-description {
  color: #2E2E2E;
  font-size: 12px;
  white-space: pre-wrap;
}
</style>
